<!-- src/components/SubMenu.vue -->
<template>
  <ul class="sub-menu">
    <li
      v-for="(childObj, childId) in nodeObj.__children"
      :key="childId"
      class="sub-menu-item"
      @mouseenter="onChildEnter(childId)"
      @mouseleave="onChildLeave(childId)"
    >
      <!-- Clicking this item navigates. We pass the path up via @navigate. -->
      <div class="sub-menu-link" @click.stop="navigate([...parentPath, nodeId, childId])">
        {{ childId }} ({{ childObj.__count }})
      </div>

      <!-- If hovered and has children, show sub-submenu to the right (recursively) -->
      <transition name="fade">
        <div
          v-if="hoverChild === childId && hasChildren(childObj)"
          class="sub-submenu"
        >
          <!-- Use the same SubMenu component for deeper levels. 
               Notice we do NOT import SubMenu again to avoid circular references. 
               We rely on the 'name: "SubMenu"' and global reference.
          -->
          <SubMenu
            :node-id="childId"
            :node-obj="childObj"
            :parent-path="[...parentPath, nodeId]"
            @navigate="$emit('navigate', $event)"
          />
        </div>
      </transition>
    </li>
  </ul>
</template>

<script>
export default {
  name: "SubMenu", // Key: so it can reference itself in the template
  props: {
    nodeId: String,  // e.g. "men-clothing"
    nodeObj: Object, // { __count: 5, __children: {...} }
    parentPath: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      hoverChild: null,
      closeDelay: 800,
      closeTimer: null
    };
  },
  methods: {
    hasChildren(obj) {
      return obj && obj.__children && Object.keys(obj.__children).length > 0;
    },
    navigate(fullPath) {
      // e.g. [ 'Web', 'men', 'men-clothing' ]
      this.$emit('navigate', fullPath);
    },
    onChildEnter(childId) {
      if (this.closeTimer) {
        clearTimeout(this.closeTimer);
        this.closeTimer = null;
      }
      this.hoverChild = childId;
    },
    onChildLeave(childId) {
      this.closeTimer = setTimeout(() => {
        if (this.hoverChild === childId) {
          this.hoverChild = null;
        }
      }, this.closeDelay);
    }
  }
};
</script>

<style scoped>
.sub-menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

.sub-menu-item {
  position: relative;
}

.sub-menu-link {
  padding: 0.3rem 0.5rem;
  cursor: pointer;
  border-radius: 4px;
  color: #444;
  margin: 2px 0;
  transition: background-color 0.2s;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.sub-menu-link:hover {
  background-color: #edf2f7;
}

/* Nested sub-submenu that appears to the right */
.sub-submenu {
  position: absolute;
  top: 0;
  left: 200px; /* offset from parent menu */
  min-width: 220px;
  padding: 0.75rem;
  background: #fff;
  border: 1px solid #ddd;
  box-shadow: 0 2px 8px rgba(0,0,0,0.2);
  z-index: 999;
}

/* Fade transition */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
